import { deleteFile, getAll } from '@/api/request'
import { setAlertError } from '@/utils/store/alert'
import CertificateController from '@/controllers/warehouse/Certificate/CertificateController'
import { throwResponseError } from '@/utils/error/throwResponseError'

export default {
  namespaced: true,
  state: {
    url: 'warehouse/w-certificates/tree',
    urlFilter: 'warehouse/w-certificates/filters',
    certificates: [],
    filterOptions: [],
    filter: {},
    isLoading: false
  },

  getters: {
    certificatesTree: state => {
      const data = state.certificates
      if (Array.isArray(data) || !data) {
        return data
      }

      return Object.entries(data).map(([gostName, dWires]) => {
        return {
          name: gostName,
          d_wires: Object.entries(dWires).map(([dWireName, dWireData]) => {
            return {
              ...dWireData,
              name: gostName,
              isNotLink: true
            }
          }),
          isFillRow: false
        }
      })
    },
    certificates: state => state.certificates,
    filterOptions: state => state.filterOptions,
    filter: state => state.filter,
    isLoading: state => state.isLoading
  },

  mutations: {
    SET_CERTIFICATES (state, certificates) {
      state.certificates = certificates
    },
    SET_IS_LOADING (state, loading) {
      state.isLoading = loading
    },

    SET_FILTER_OPTIONS (state, data) {
      state.filterOptions = data
    },

    SET_FILTER (state, data) {
      state.filter = data
    },

    RESET_FILTER (state) {
      state.filter = {}
    }
  },
  actions: {
    // Получение дерева сертификатов
    async getCertificatesTree ({ state, commit }) {
      try {
        commit('SET_IS_LOADING', true)
        const params = {
          ...state.filter
        }

        const response = await getAll(state.url, params)
        commit('SET_CERTIFICATES', response.data)
      } catch (e) {
        await setAlertError(e, 'Не удалось загрузить список сертификатов')
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    // Получение фильтров для сертификатов
    async getCertificatesFilters ({ state, commit }) {
      try {
        const response = await getAll(state.urlFilter)
        commit('SET_FILTER_OPTIONS', response.data)
      } catch (e) {
        await setAlertError(e, 'Не удалось загрузить данные для фильтра')
      }
    },

    // Добавление сертификата
    async addCertificate ({ commit, dispatch }, data) {
      return await CertificateController.create(data)
    },

    // Редактирование сертификата
    async updateCertificate ({ commit, dispatch }, data) {
      return await CertificateController.update(data)
    },

    // Удаление сертификата (name и d_wire)
    async deleteCertificate ({ state, dispatch }, data) {
      return CertificateController.delete(data)
    },

    // Добавление файлов сертификата
    async addCertificateFile ({ state, dispatch }, { id, data }) {
      return await CertificateController.addFilesCertificate(id, data)
    },

    // Замена файла сертификата
    async changeCertificateFile ({ state, dispatch }, { id, data }) {
      return await CertificateController.changeFile(id, data)
    },

    // Удаление файла
    async deleteCertificateFile ({ state, dispatch }, id) {
      try {
        return await deleteFile(id)
      } catch (e) {
        throwResponseError(e, 'Не удалось удалить файл')
      }
    }
  }
}
